<p-tabs value="0" #tabs scrollable>
    <p-tablist>
        <ng-container *ngFor="let f of field.fieldGroup; let index = index">
            @if (!f.hide) {
                <p-tab value="{{ index }}" #tab>
                    <span
                        *ngIf="f.templateOptions.icon"
                        style="margin-right: 3pt"
                        [class]="f.templateOptions.icon"
                        [attr.data-testid]="'formly-document-postal-addresses-widget-icon-' + f.key"
                    ></span>
                    <span 
                        class="h6 flex items-center gap-2" 
                        [ngClass]="{ 'font-bold': tab.value() == tabs.value(), 'font-extrabold': hasPostalAddressContent(index) }">
                        {{ getTabTitle(index) }}
                        @if (hasPostalAddressContent(index)) {
                            <span 
                                class="w-2 h-2 bg-primary-500 rounded-full" 
                                [attr.data-testid]="'formly-document-postal-addresses-widget-content-indicator-' + f.key"
                            ></span>
                        }
                    </span>
                </p-tab>
            }
        </ng-container>
    </p-tablist>

    <p-tabpanels>
        <ng-container *ngFor="let f of field.fieldGroup; let index = index">
            @if (!f.hide) {
                <p-tabpanel value="{{ index }}">
                    <ng-container>
                        <formly-field [field]="f"></formly-field>
                    </ng-container>
                </p-tabpanel>
            }
        </ng-container>
    </p-tabpanels>
</p-tabs>
